import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import { noop } from 'ui-components/default-props/noop';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalPortal } from '../../../../components/modal-portal';
import { CuiMarketplaceConnection } from '../../../../connection-components/marketplace-connection';
import { useEnableRemoveIframeMarketplace } from '../../../../feature-flags/hooks/use-enable-remove-iframe-marketplace';
import { useMarketplaceApiCodeFromStoreGuid } from '../../../../hooks/use-marketplace-api-code-from-store-guid';

import style from './style.module.less';

const MarketplaceConnectionModal = ({
  onClose,
  onSave,
  onError = noop,
  marketplaceApiCode = '',
  storeGuid = '',
  redirectPath = '',
  onRedirect = noop,
}) => {
  const isDirectMode = useEnableRemoveIframeMarketplace();
  const calculatedMarketplaceApiCode = useMarketplaceApiCodeFromStoreGuid(storeGuid);
  let realMarketplaceApiCode = marketplaceApiCode;
  if (!marketplaceApiCode && storeGuid) {
    realMarketplaceApiCode = calculatedMarketplaceApiCode;
  }
  return (
    <ModalPortal containerId='marketplace-settings-modal' onClose={onClose}>
      <Modal className={style['marketplace-settings-modal']}>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage
            defaultMessage='Set Up Marketplace Connection'
            description='src.pages.settings.stores.store-settings-modal'
            id='E+Aew2'
          />
        </ModalHeader>
        <ModalBody className={cx(style['modal-body'], { [style['iframe-mode']]: !isDirectMode })}>
          <CuiMarketplaceConnection
            marketplaceApiCode={realMarketplaceApiCode}
            onCancel={onClose}
            onError={onError}
            onRedirect={onRedirect}
            onSave={onSave}
            redirectPath={redirectPath}
            storeGuid={storeGuid}
          />
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};

MarketplaceConnectionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  marketplaceApiCode: PropTypes.string,
  storeGuid: PropTypes.string,
  redirectPath: PropTypes.string,
  onRedirect: PropTypes.func,
};

export default MarketplaceConnectionModal;
